import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { RoleGuard } from './guards/role-guard';


const routes: Routes = [
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then( m => m.HomePageModule)
  },
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'admin',
    loadChildren: () => import('./pages/admin/admin.module').then( m => m.AdminPageModule),
    canActivate: [RoleGuard],
    data: { roles: ['Administrador'] }
  },
  {
    path: 'tecnico',
    loadChildren: () => import('./pages/tecnico/tecnico.module').then( m => m.TecnicoPageModule),
    canActivate: [RoleGuard],
    data: { roles: ['Administrador', 'Tecnico'] }
  },
  {
    path: 'vendedor',
    loadChildren: () => import('./pages/vendedor/vendedor.module').then( m => m.VendedorPageModule),
    canActivate: [RoleGuard],
    data: { roles: ['Administrador', 'Vendedor'] }
  },
  {
    path: 'almacen',
    loadChildren: () => import('./pages/almacen/almacen.module').then( m => m.AlmacenPageModule),
    canActivate: [RoleGuard],
    data: { roles: ['Administrador', 'Almacen'] }
  },
  {
    path: 'detalle-orden/:id',
    loadChildren: () => import('./pages/detalle-orden/detalle-orden.module').then( m => m.DetalleOrdenPageModule),
    canActivate: [RoleGuard],
    data: { roles: ['Administrador', 'Tecnico', 'Almacen', 'Vendedor'] }
  },
  {
    path: 'nueva-orden',
    loadChildren: () => import('./pages/nueva-orden/nueva-orden.module').then( m => m.NuevaOrdenPageModule),
    canActivate: [RoleGuard],
    data: { roles: ['Administrador', 'Vendedor'] }
  },{
    path: 'nueva-orden/:id',
    loadChildren: () => import('./pages/nueva-orden/nueva-orden.module').then( m => m.NuevaOrdenPageModule),
    canActivate: [RoleGuard],
    data: { roles: ['Administrador', 'Vendedor'] }
  },
  {
    path: 'usuarios',
    loadChildren: () => import('./pages/usuarios/usuarios.module').then( m => m.UsuariosPageModule)
  },
  {
    path: 'cotizador',
    loadChildren: () => import('./pages/cotizador/cotizador.module').then( m => m.CotizadorPageModule),
    canActivate: [RoleGuard],
    data: { roles: ['Administrador', 'Vendedor'] }
  },
  {
    path: 'cotizador/:id',
    loadChildren: () => import('./pages/cotizador/cotizador.module').then( m => m.CotizadorPageModule),
    canActivate: [RoleGuard],
    data: { roles: ['Administrador', 'Vendedor'] }
  },
  {
    path: 'cotizaciones',
    loadChildren: () => import('./pages/cotizaciones/cotizaciones.module').then( m => m.CotizacionesPageModule),
    canActivate: [RoleGuard],
    data: { roles: ['Administrador', 'Vendedor'] }
  },
  {
    path: 'detalles-cotizacion/:id',
    loadChildren: () => import('./pages/detalles-cotizacion/detalles-cotizacion.module').then( m => m.DetallesCotizacionPageModule),
    canActivate: [RoleGuard],
    data: { roles: ['Administrador', 'Vendedor'] }
  },
  {
    path: 'visitas-lista',
    loadChildren: () => import('./pages/visitas-lista/visitas-lista.module').then( m => m.VisitasListaPageModule),
    canActivate: [RoleGuard],
    data: { roles: ['Administrador', 'Tecnico', 'Vendedor'] }
  },
  {
    path: 'nueva-visita',
    loadChildren: () => import('./pages/nueva-visita/nueva-visita.module').then( m => m.NuevaVisitaPageModule),
    canActivate: [RoleGuard],
    data: { roles: ['Administrador', 'Tecnico', 'Vendedor'] }
  },
  {
    path: 'detalle-visita',
    loadChildren: () => import('./pages/detalle-visita/detalle-visita.module').then( m => m.DetalleVisitaPageModule),
    canActivate: [RoleGuard],
    data: { roles: ['Administrador', 'Tecnico', 'Vendedor'] }
  },
  {
    path: 'detalle-visita/:id',
    loadChildren: () => import('./pages/detalle-visita/detalle-visita.module').then( m => m.DetalleVisitaPageModule),
    canActivate: [RoleGuard],
    data: { roles: ['Administrador', 'Tecnico', 'Vendedor'] }
  },
  {
    path: 'dashboard-page',
    loadChildren: () => import('./pages/dashboard-page/dashboard-page.module').then( m => m.DashboardPagePageModule),
    canActivate: [RoleGuard],
    data: { roles: ['Administrador', 'Tecnico', 'Almacen', 'Vendedor'] }
  },
  {
    path: 'catalogo-precios',
    loadChildren: () => import('./pages/catalogo-precios/catalogo-precios.module').then( m => m.CatalogoPreciosPageModule),
    canActivate: [RoleGuard],
    data: { roles: ['Administrador', 'Tecnico', 'Vendedor'] }
  },  {
    path: 'abastecimiento',
    loadChildren: () => import('./pages/abastecimiento/abastecimiento.module').then( m => m.AbastecimientoPageModule)
  },
  {
    path: 'abastecimiento-lista',
    loadChildren: () => import('./pages/abastecimiento-lista/abastecimiento-lista.module').then( m => m.AbastecimientoListaPageModule)
  },
  {
    path: 'proveedores',
    loadChildren: () => import('./pages/proveedores/proveedores.module').then( m => m.ProveedoresPageModule)
  },
  {
    path: 'nueva-cubierta',
    loadChildren: () => import('./pages/nueva-cubierta/nueva-cubierta.module').then( m => m.NuevaCubiertaPageModule)
  },
  {
    path: 'lista-cubiertas',
    loadChildren: () => import('./pages/lista-cubiertas/lista-cubiertas.module').then( m => m.ListaCubiertasPageModule)
  },
  {
    path: 'registrar-carga',
    loadChildren: () => import('./pages/registrar-carga/registrar-carga.module').then( m => m.RegistrarCargaPageModule)
  },
  {
    path: 'control-vehicular-dashboard',
    loadChildren: () => import('./pages/control-vehicular-dashboard/control-vehicular-dashboard.module').then( m => m.ControlVehicularDashboardPageModule)
  },
  {
    path: 'nueva-unidad',
    loadChildren: () => import('./pages/nueva-unidad/nueva-unidad.module').then( m => m.NuevaUnidadPageModule)
  },
  {
    path: 'corte-kilometraje',
    loadChildren: () => import('./pages/corte-kilometraje/corte-kilometraje.module').then( m => m.CorteKilometrajePageModule)
  },
  {
    path: 'tarjetas',
    loadChildren: () => import('./pages/tarjetas/tarjetas.module').then( m => m.TarjetasPageModule)
  },




];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
